import React, { Children } from 'react';
import { motion } from 'framer-motion';
const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
interface MilestoneProps {
  quarter: string;
  label: string;
  customers: string;
  tokens: string;
  revenue: string;
  isActive?: boolean;
  isFuture?: boolean;
}
function Milestone({
  quarter,
  label,
  customers,
  tokens,
  revenue,
  isActive,
  isFuture
}: MilestoneProps) {
  return <motion.div variants={fadeUp} className="flex gap-4 items-start" data-id="element-400">
      {/* Timeline dot + line */}
      <div className="flex flex-col items-center flex-shrink-0" data-id="element-401">
        <div className={`w-3.5 h-3.5 rounded-full border-2 ${isActive ? 'border-[#00d4ff] bg-[#00d4ff] shadow-[0_0_10px_rgba(0,212,255,0.5)]' : isFuture ? 'border-[rgba(255,255,255,0.2)] bg-transparent' : 'border-[#00d4ff] bg-[rgba(0,212,255,0.3)]'}`} data-id="element-402" />
        <div className="w-[1px] h-full min-h-[40px] bg-[rgba(255,255,255,0.08)]" data-id="element-403" />
      </div>

      {/* Content */}
      <div className={`glass-card p-4 flex-1 mb-2 ${isActive ? 'border-l-2 border-l-[#00d4ff] glow-cyan' : ''}`} data-id="element-404">
        <div className="flex items-baseline gap-2 mb-1.5" data-id="element-405">
          <span className={`text-xl font-bold ${isActive ? 'text-[#00d4ff]' : 'text-white/70'}`} data-id="element-406">
            {quarter}
          </span>
          <span className="text-base text-[#8899aa]" data-id="element-407">{label}</span>
        </div>
        <div className="flex flex-wrap gap-x-5 gap-y-1 text-base" data-id="element-408">
          <span className="text-white/80" data-id="element-409">
            <span className="text-[#ff6b35] font-semibold" data-id="element-410">{customers}</span>{' '}
            customers
          </span>
          <span className="text-white/80" data-id="element-411">
            <span className="text-[#00d4ff] font-semibold" data-id="element-412">{tokens}</span>{' '}
            tokens/mo
          </span>
          <span className="text-white/80" data-id="element-413">
            <span className="text-green-400 font-semibold" data-id="element-414">{revenue}</span> run
            rate
          </span>
        </div>
      </div>
    </motion.div>;
}
export function TractionSlide() {
  return <motion.div className="w-full h-full flex flex-col px-12 py-10" variants={stagger} initial="hidden" animate="visible" data-id="element-415">
      <motion.div variants={fadeUp} className="flex items-center gap-3 mb-2" data-id="element-416">
        <span className="text-base text-[#00d4ff] font-semibold tracking-widest uppercase" data-id="element-417">
          07
        </span>
        <span className="w-8 h-[1px] bg-[#00d4ff] opacity-50" data-id="element-418" />
      </motion.div>

      <motion.h2 variants={fadeUp} className="text-4xl md:text-5xl font-extrabold text-white mb-2" data-id="element-419">
        Traction / Progress
      </motion.h2>

      <motion.p variants={fadeUp} className="text-2xl text-[#8899aa] mb-6" data-id="element-420">
        Early validation: design partners and beta pilots
      </motion.p>

      <div className="flex-1 flex flex-col md:flex-row gap-6" data-id="element-421">
        {/* Timeline */}
        <div className="flex-1 flex flex-col" data-id="element-422">
          <motion.div variants={fadeUp} className="flex gap-4 items-start mb-1" data-id="element-423">
            <div className="flex flex-col items-center flex-shrink-0" data-id="element-424">
              <div className="w-3.5 h-3.5 rounded-full border-2 border-[#ff6b35] bg-[#ff6b35] shadow-[0_0_10px_rgba(255,107,53,0.5)]" data-id="element-425" />
              <div className="w-[1px] h-8 bg-[rgba(255,255,255,0.08)]" data-id="element-426" />
            </div>
            <div className="glass-card p-3 flex-1 border-l-2 border-l-[#ff6b35]" data-id="element-427">
              <span className="text-xl font-bold text-[#ff6b35]" data-id="element-428">Now</span>
              <span className="text-base text-[#8899aa] ml-2" data-id="element-429">Pre-launch</span>
            </div>
          </motion.div>

          <Milestone quarter="26Q1" label="Beta Launch" customers="5" tokens="500K queries" revenue="$30K" isActive data-id="element-430" />
          <Milestone quarter="26Q2" label="Growth" customers="10" tokens="125B" revenue="$150K" isFuture data-id="element-431" />
          <Milestone quarter="26Q3" label="Scale" customers="50" tokens="1T" revenue="$1M" isFuture data-id="element-432" />
          <Milestone quarter="26Q4" label="Expansion" customers="100" tokens="2T" revenue="$2M" isFuture data-id="element-433" />
        </div>
      </div>
    </motion.div>;
}